import { z } from "zod";

export const getCommentSchema = () => {
  const t =
    (window as any).commonVariables?.translations?.comments?.validation || {};
  return z.object({
    post_id: z.coerce.number(),
    name: z.string().min(2, t.nameMin || "Geçersiz isim"),
    email: z.string().email(t.emailInvalid || "Geçersiz e-posta"),
    message: z.string().min(5, t.messageMin || "Mesaj çok kısa"),
    nickname: z.string().optional(),
    form_load_timestamp: z.coerce.number(),
    recaptcha_token: z.string().optional(),
  });
};
